import { render } from "./UserBilling.vue?vue&type=template&id=77214264"
import script from "./UserBilling.vue?vue&type=script&lang=js"
export * from "./UserBilling.vue?vue&type=script&lang=js"
script.render = render

export default script